// Copyright (c) StrangeBee 2023

import { THCheckbox } from '@Molecules/Inputs/THCheckbox/THCheckbox';
import { THForm } from '@Molecules/THForm/THForm';
import React, { ReactElement } from 'react';

import './BulkEditFormField.scss';

interface BulkEditFormFieldProps {
    input: ReactElement;
    name: string;
    label: string;
    hidden?: boolean;
}

export const BulkEditFormField = ({ input, name, label, hidden = false }: BulkEditFormFieldProps): ReactElement => (
    <THForm.Item
        className="bulk-edit-form-field"
        name={name}
        hidden={hidden}
        label={
            <div className="bulk-edit-form-field__label">
                <span className="bulk-edit-form-field__label__title">{label}</span>

                <THForm.Item
                    className="bulk-edit-form-field__label__checkbox"
                    horizontal
                    name={`${name}Checked`}
                    valuePropName="checked"
                >
                    <THCheckbox />
                </THForm.Item>
            </div>
        }
    >
        {input}
    </THForm.Item>
);
